export default __webpack_public_path__ + "static/media/massup_l1.27e00a5f.png";